import { useEffect, useState } from "react";
import { workerJsSource } from "../constants";
var blobObject = URL.createObjectURL(new Blob([workerJsSource], {
  type: "application/javascript"
}));
console.log("Creating first worker");
var workerPool = [new Worker(blobObject)];
var useWorker = function useWorker(_a) {
  var debug = _a.debug;
  var _b = useState(),
    worker = _b[0],
    setWorker = _b[1];
  var _c = useState([]),
    messageBuffer = _c[0],
    setMessageBuffer = _c[1];
  var createWorker = function createWorker() {
    debug && console.log("Workerpool length is", workerPool.length);
    var w = workerPool.pop();
    if (workerPool.length === 0) {
      debug && console.log("Creating another worker");
      workerPool.push(new Worker(blobObject));
    } else {
      debug && console.log("Returning worker without creating new");
    }
    setWorker(w);
  };
  var setMessageListener = function setMessageListener(listener) {
    if (worker) {
      worker.onmessage = listener;
    }
  };
  var postMessage = function postMessage(message) {
    if (worker) {
      worker.postMessage(message);
    } else {
      setMessageBuffer(function (prev) {
        return prev.concat(message);
      });
      createWorker();
    }
  };
  var terminate = function terminate() {
    debug && console.log("Terminating worker");
    if (worker) {
      worker.onmessage = null;
      worker.terminate();
      setWorker(undefined);
    }
  };
  var recycle = function recycle() {
    if (worker) {
      workerPool.push(worker);
      debug && console.log("Recycling worker, pool size:", workerPool.length);
    }
    setWorker(undefined);
  };
  useEffect(function () {
    if (worker) {
      messageBuffer.forEach(function (message) {
        return worker.postMessage(message);
      });
      setMessageBuffer([]);
    }
  }, [worker]);
  return [{
    setMessageListener: setMessageListener,
    postMessage: postMessage,
    recycle: recycle,
    terminate: terminate
  }];
};
export { useWorker };